import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Input,
} from '@angular/core';
import { PopoverController } from '@ionic/angular';

import { Sale } from '../../../models/sale/sale.model';
@Component({
  selector: 'app-sale-more-options-popover',
  templateUrl: './sale-more-options-popover.page.html',
  styleUrls: ['./sale-more-options-popover.page.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SaleMoreOptionsPopoverPage {
  @Input() sale: Sale;

  constructor(
    //private navParams: NavParams,
    private popOverCtrl: PopoverController
  ) {
    // this.sale = this.navParams.get('sale');
  }

  public putSaleOnHold() {
    //this.viewCtrl.dismiss('onhold');
    this.popOverCtrl.dismiss('onhold');
  }

  public cancelSale() {
    this.popOverCtrl.dismiss('cancel');
  }
}
